import { createApp } from 'vue'
import store from 'store'
import ProductInfo from './ProductInfo.vue'

const el = '.nti-component--product-info'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const app = createApp(ProductInfo)
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}